import { useMemo } from 'react';
import { NextPage } from 'next';

import { PageSection } from 'types/pages';
import { Routes } from 'types/routes';

import { withVariables } from 'utils/string';

import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import SectionsWrapper from 'components/layout/SectionsWrapper';
import SectionCta from 'components/pages/Home/sections/Cta';
import WrapperPublic from 'components/wrappers/Public';

import SectionArticles from './sections/Articles';
import SectionHero from './sections/Hero';
import StyledComponent from './styles';
import { Props } from './types';

const PageBlog: NextPage<Props> = ({ pageTranslations, articles }) => {
    const sections: PageSection[] = useMemo(() => [
        {
            slug: 'hero',
            order: 1,
            isVisible: true,
            children: (slug, translations) => (
                <SectionHero
                    key={slug}
                    translations={translations}
                    articles={articles}
                />
            ),
        },
        {
            slug: 'articles',
            order: 2,
            isVisible: true,
            children: (slug, translations) => (
                <SectionArticles
                    key={slug}
                    articles={articles}
                    translations={translations}
                />
            ),
        }, {
            slug: 'cta',
            order: 3,
            isVisible: true,
            children: (slug, translations) => (
                <SectionCta
                    key={slug}
                    translations={translations}
                />
            ),
        },
    ], []);

    return (
        <WrapperPublic>
            <StyledComponent className="page-blog">
                <Head
                    title={pageTranslations?.page?.metaTitle}
                    description={pageTranslations?.page?.metaDescription}
                    canonical={withVariables(Routes.PublicBlog)}
                />
                <PageContainer>
                    <SectionsWrapper
                        sections={sections}
                        localTranslations={pageTranslations?.sections}
                        enabledStates={pageTranslations?.sectionsEnabled}
                    />
                </PageContainer>
            </StyledComponent>
        </WrapperPublic>
    );
};

export default PageBlog;
